import { ReactElement } from 'react';
import { Subpage } from '../Overview/OverviewSubpage';
import { MeasureDeadlinesCard } from './MeasureDeadlinesCard';

export const HRMeasureDeadlines = (): ReactElement => (
  <Subpage page="measures">
    <MeasureDeadlinesCard />
  </Subpage>
);
